import tc from "common/common/tcHelpers";

angular
  .module("ticketco/common/arena")
  .directive("arenaDisabled", arenaDisabled);

var removeClassDisabled = tc.dom.removeClass("__disabled");
var addClassDisabled = tc.dom.addClass("__disabled");

function arenaDisabled($parse) {
  return {
    require: "tcArena",
    link: function link(scope, elem, attrs, ctrl) {
      var checkIfDisableChanged = function () {
        return $parse(attrs.arenaDisabled)(scope);
      };

      var disableChangeHandler = function (disabledSections) {
        // Remove '__selected' class from all sections
        R.pipe(ctrl.$getSections, R.forEach(removeClassDisabled))();

        // Add '__selected' class to some sections
        R.forEach(
          R.pipe(
            tc.dom.attrEq("tc:name"),
            ctrl.$getSections,
            R.forEach(addClassDisabled)
          )
        )(disabledSections || []);
        R.pipe(
          ctrl.$getSections,
          R.forEach(function (el) {
            let parent = tc.dom.parent(el);
            if (tc.dom.hasClass("__disabled", el)) {
              tc.dom.setAttr("xlink:href", "#", parent);
            }
          })
        )();
      };

      scope.$watch(checkIfDisableChanged, disableChangeHandler);
    },
  };
}
